import {MuiIcons} from "@leap4/frontend";
import ReportHeader from "../../../common/ReportHeader/ReportHeader";
import {urlService} from "../../../../routing/urlsService";

const { Tag, GpsFixed: GpsFixedIcon, LocationSearching: LocationSearchingIcon, Toc: TocIcon } = MuiIcons;

export const ReportHeaderWithProps = ({entityName, entityId}:{entityName:string, entityId: string}) => (
    <ReportHeader breadcrumbsIcon={<Tag/>} breadcrumbs={[
        {text: "AdServers Dashboard", link: urlService.adServers(), icon: <TocIcon />},
        {text: entityName? `${entityName} Details`: "AdServer Details", link: urlService.editAdServer(entityId), icon: <LocationSearchingIcon /> },
        {text: entityName || "Loading...", icon: <GpsFixedIcon />},
    ]}/>
)